import { useContext } from "react";

import { ProjectContext } from "../../ProjectContext";

interface UseDocumentsTabWithPreAccessReturnData {
  hasFullAccess: boolean;
}

export const useDocumentsTabWithPreAccess = (): UseDocumentsTabWithPreAccessReturnData => {
  const { projectDetails } = useContext(ProjectContext);

  return { hasFullAccess: !!projectDetails };
};
